import script from "./EditPopupEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPopupEvent.vue?vue&type=script&setup=true&lang=ts"

import "./EditPopupEvent.vue?vue&type=style&index=0&id=4d16fcaf&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d16fcaf"]])

export default __exports__